// OWNER CONTROLLERS
export const C_OWNER_REPORT = 'report';
export const C_OWNER_REPORT_BRANCH_COVERS = `${C_OWNER_REPORT}--branch-covers`;
export const C_OWNER_REPORT_DINE_IN = `${C_OWNER_REPORT}--dine-in`;
export const C_OWNER_REPORT_DINE_IN_COVERS = `${C_OWNER_REPORT}--dine-in-covers`;
export const C_OWNER_REPORT_FILTER = `${C_OWNER_REPORT}--filter`;
export const C_OWNER_REPORT_PACKAGE_REPORT = `${C_OWNER_REPORT}--package-report`;
export const C_OWNER_REPORT_RATING = `${C_OWNER_REPORT}--rating`;
export const C_OWNER_REPORT_SERVICE_TYPE = `${C_OWNER_REPORT}--service-type`;
export const C_OWNER_REPORT_SOLD_OUT = `${C_OWNER_REPORT}--sold-out`;
export const C_OWNER_REPORT_SOLD_OUT_PER_DATE = `${C_OWNER_REPORT}--sold-out-per-date`;

// ADMIN CONTROLLERS
export const C_ADMIN_USER_SHOW = 'user--show';

// BLOGGER CONTROLLERS
export const C_BLOGGER_BLOG = 'blog';